import { css } from '@emotion/core'
import { mediumUp } from 'Utils'

export const plain = ({
  theme: {
    colors,
    typography,
    components: { productCard }
  }
}) => {
  return css`
    max-width: 300px;
    background-color: ${colors.bg4};
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .image-link {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 250px;
      background-color: ${colors.complementary.primary};

      img {
        flex-shrink: 0;
        object-fit: contain;
        max-height: 230px;
        display: block;
      }

      @media ${mediumUp} {
        height: 300px;
        img {
          max-height: 280px;
        }
      }
    }

    .footer {
      color: ${colors.body};
      height: 100px;
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: black;
      transition: all 0.2s ease;
      font-size: ${typography.sizes.small};

      h4 {
        color: ${colors.body};
        line-height: 1.2rem;
        font-family: ${typography.body.fontFamily};
      }
    }

    .discount {
      text-decoration: line-through;
      color: ${productCard.discountColor};
    }

    @media ${mediumUp} {
      .footer {
        font-size: ${typography.baseFontSize};
        height: 100px;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: all 0.2s ease;

        h4 {
          color: ${colors.body};
          line-height: 1rem;
          font-family: ${typography.body.fontFamily};
        }
      }
    }
  `
}

export default plain
